import styled from 'styled-components';

const Top = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 15px;
  position: relative;
  z-index: 100;

  .buttons-form {
    display: flex;
    justify-content: flex-end

    button {
      align-self: flex-end;
    }
  } 

  ${props => props.theme.media.phone`
		grid-template-columns: 1fr;
	`}
`;

const Bottom = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;

  ${props => props.theme.media.tablet`
		flex-direction: column;
    
    button {
      width: 100%;

      &:first-of-type {
        margin-bottom: 20px;
      }
    }
	`}
`;

const RemoveButton = styled.div`
  border-radius: 8px;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${props => props.theme.colors.danger};

  svg {
    color: white;
  }
`;

const Label = styled.div`
  width: 100%;
  text-align: right;
  font-weight: 600;
  margin-bottom: 20px;
`;

export { Top, Bottom, RemoveButton, Label };
